"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  attachmentAttr: () => attachmentAttr,
  attributeGroup: () => attributeGroup,
  booleanAttr: () => booleanAttr,
  enumAttr: () => enumAttr,
  featureAttr: () => featureAttr,
  numberAttr: () => numberAttr,
  stringAttr: () => stringAttr,
  surveyAttr: () => surveyAttr,
  surveyorAttr: () => surveyorAttr,
  teamAttr: () => teamAttr,
  timestampAttr: () => timestampAttr
});
module.exports = __toCommonJS(create_exports);
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_bucket = require("../bucket/index.js");
var import_marker = require("../marker/index.js");
var import_helpers = require("./helpers.js");
function featureAttr(props) {
  const { attributeId, label, marker = import_marker.marker.standard } = props;
  return { type: "FeatureAttribute", attributeId, label, marker };
}
function stringAttr(props) {
  const {
    attributeId,
    label,
    propertyName = attributeId,
    format = import_helpers.stringFormatter,
    unit,
    buckets,
    showDistribution = true
  } = props;
  return {
    type: "StringAttribute",
    attributeId,
    label,
    propertyName,
    format,
    unit,
    buckets: (0, import_helpers.wrapBuckets)(buckets),
    showDistribution
  };
}
function enumAttr(props) {
  const {
    attributeId,
    label,
    propertyName = attributeId,
    unit,
    enum: _enum,
    markers: markers2,
    noneValue,
    showDistribution = true
  } = props;
  return {
    type: "StringAttribute",
    attributeId,
    label,
    propertyName,
    format: (0, import_helpers.enumFormatter)(_enum),
    unit,
    buckets: (0, import_bucket.enumBuckets)(_enum, markers2, noneValue),
    showDistribution
  };
}
function numberAttr(props) {
  const {
    attributeId,
    label,
    propertyName = attributeId,
    decimalPlaces,
    format = (0, import_helpers.numberFormatter)(decimalPlaces),
    unit,
    buckets,
    showDistribution = true,
    showTimeline = true
  } = props;
  return {
    type: "NumberAttribute",
    attributeId,
    label,
    propertyName,
    format,
    unit,
    buckets: (0, import_helpers.wrapBuckets)(buckets),
    showDistribution,
    showTimeline
  };
}
function booleanAttr(props) {
  const {
    attributeId,
    label,
    propertyName = attributeId,
    format = import_helpers.booleanFormatter,
    buckets,
    showDistribution = true
  } = props;
  return {
    type: "BooleanAttribute",
    attributeId,
    label,
    propertyName,
    format,
    buckets: (0, import_helpers.wrapBuckets)(buckets),
    showDistribution
  };
}
function timestampAttr(props) {
  const {
    attributeId,
    label,
    propertyName = attributeId,
    format = import_types.ddmmyyyy,
    timeZone = import_types.defaultTimeZone,
    buckets,
    showDistribution = true
  } = props;
  return {
    type: "TimestampAttribute",
    attributeId,
    label,
    propertyName,
    format: (0, import_helpers.timestampFormatter)(format, timeZone),
    buckets: (0, import_helpers.wrapBuckets)(buckets),
    showDistribution
  };
}
function surveyAttr(attributeId, label = "Survey", propertyName = attributeId) {
  return { type: "SurveyAttribute", attributeId, label, propertyName };
}
function teamAttr(attributeId, label, options = {}) {
  const { propertyName = attributeId, marker } = options;
  return { type: "TeamAttribute", attributeId, label, propertyName, marker };
}
function attachmentAttr(attributeId, label = "Attachments", surveyPropertyName = "surveyId", folderPropertyName = attributeId) {
  return {
    type: "AttachmentAttribute",
    attributeId,
    label,
    surveyPropertyName,
    folderPropertyName
  };
}
function surveyorAttr(attributeId = "surveyorScreenName") {
  return stringAttr({ attributeId, label: "Surveyor", buckets: "auto" });
}
function attributeGroup(props) {
  if ((0, import_guard.isArray)(props)) {
    return { type: "AttributeGroup", attributes: props };
  } else {
    return { type: "AttributeGroup", ...props };
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  attachmentAttr,
  attributeGroup,
  booleanAttr,
  enumAttr,
  featureAttr,
  numberAttr,
  stringAttr,
  surveyAttr,
  surveyorAttr,
  teamAttr,
  timestampAttr
});
//# sourceMappingURL=create.js.map
